import SearchPagination from '@react/search/components/SearchPagination';
import useSearch from '@react/search/hooks/useSearch';
import EntityTile from '@sly/frontend/react/card';
import React from 'react';

const ExploreCommunities = ({ partnerCollection }) => {
  const { communities, pagination } = useSearch({
    'filter[partnerCollection]': partnerCollection?.id,
  });

  if (communities?.length) {
    return (
      <>
        <div
          className='mt-6 grid auto-rows-auto gap-6 md:grid-cols-2 lg:grid-cols-3'
          data-tp-id='gen-div-f44ab4b6-63d5-49cf-afaf-b6a42dcf4f8f'
        >
          {communities.map((community) => (
            <EntityTile
              key={community.id}
              entity={community}
              intent='vertical'
            />
          ))}
        </div>

        <SearchPagination pagination={pagination} />
      </>
    );
  }
};

export default ExploreCommunities;
